import classNames from "classnames";
import { Icon } from "client/Components";
import { WorkspaceHeaderStyle } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { ReactElement } from "react";
import styles from "./Render.module.less";
import { TitleBarButtonProps } from "./TitleBarButton";
import { isNotNilOrEmpty } from "client/Misc/utils";

export type RenderProps = Omit<TitleBarButtonProps, "onClick" | "trackingId">;

export const Render = (props: RenderProps): ReactElement => {
	const {
		icon,
		text,
		headerStyle
	} = props;

	return (
		<span
			className={classNames(
				styles.root,
				{
					[styles.root_coloredHeader]: headerStyle === WorkspaceHeaderStyle.ColoredBackground,
					[styles.root_iconOnly]: !text
				}
			)}
		>
			<Icon value={icon} />
			{isNotNilOrEmpty(text) && (
				<span>{text}</span>
			)}
		</span>
	);
};
Render.displayName = "Render";